import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, Row} from 'antd';

import {Gift, PersonWhoBookedGift} from 'types';

import * as statuses from 'constants/statuses';
import useShowModalsActions from 'hooks/useShowModalsActions';

import GiftItem from 'pages/Gifts/components/GiftItem';
import SearchForGuest from 'pages/Gifts/components/SearchForGuest';
import Pagination from 'pages/Gifts/components/Pagination';

import {getListGifts, getPagination, getSearch} from 'pages/Gifts/selectors';
import * as actions from 'pages/Gifts/actions/guestActions';
import {changePaginationPage, changeSearchParams, clearSearchParams} from 'pages/Gifts/actions/commonActions';
import CharityEventInfo from 'pages/Gifts/components/ActiveGifts/components/CharityEventInfo';

const GuestRoleList: React.FC = () => {
    const gifts = useSelector(getListGifts);
    const searchParams = useSelector(getSearch);
    const pagination = useSelector(getPagination);
    const {showBookGiftModal} = useShowModalsActions();
    const dispatch = useDispatch();
    const searchByFreeStatus = useCallback(
        isNeedSearchByFreeStatus => {
            dispatch(changeSearchParams({status: isNeedSearchByFreeStatus ? statuses.GIFT_STATUS_FREE : ''}));
        },
        [dispatch],
    );
    const searchByMonthHandler = useCallback(
        data => {
            dispatch(changeSearchParams({month: data.month}));
        },
        [dispatch],
    );
    const clearSearchParamsHandler = useCallback(() => {
        dispatch(clearSearchParams());
    }, [dispatch]);
    const showBookGiftModalHandler = useCallback(
        (gif: Gift) => {
            showBookGiftModal(gif, (bookedPerson: PersonWhoBookedGift): void => {
                dispatch(actions.bookGift(gif, bookedPerson));
            });
        },
        [dispatch, showBookGiftModal],
    );
    const changePaginationPageHandler = useCallback(
        (nextPage: number) => {
            dispatch(changePaginationPage(nextPage));
        },
        [dispatch],
    );
    useEffect(() => {
        dispatch(actions.fetchGifts({searchParams, pagination: {page: pagination.page, size: pagination.size}}));
    }, [dispatch, searchParams, pagination.page, pagination.size]);

    return (
        <div>
            <CharityEventInfo />
            <SearchForGuest
                searchParams={searchParams}
                onSearchFreeGifts={searchByFreeStatus}
                onClearParams={clearSearchParamsHandler}
                onSearchByMonth={searchByMonthHandler}
            />
            <Row className="gift-list-row" type="flex">
                {gifts.map((gift: Gift) => (
                    <Col lg={6} md={12} xs={24} key={gift._id}>
                        <GiftItem gift={gift} isAdmin={false} onBookItem={showBookGiftModalHandler} />
                    </Col>
                ))}
            </Row>
            {gifts.length > 0 && (
                <Pagination
                    allPages={pagination.pagesCount}
                    currentPage={pagination.page}
                    onPageChange={changePaginationPageHandler}
                />
            )}
        </div>
    );
};

export default GuestRoleList;
